import { Tag } from '@carbon/react';
import { Information } from '@carbon/react/icons';
import styles from './operator-tag.module.scss';

export const OPERATOR_TAG_LABEL = 'Operator: linked to an operator code';

// Marks an entity tagged Operator (a code points at it or, for a primary, at one of
// its aliases), whatever its type. The icon sits in the label because Carbon drops
// renderIcon on sm tags.
export const OperatorTag = ({ className }: { className?: string }) => (
  <Tag type="purple" size="sm" className={className}>
    <span
      className={styles.label}
      title={OPERATOR_TAG_LABEL}
      aria-label={OPERATOR_TAG_LABEL}
    >
      <Information size={16} />
      Operator
    </span>
  </Tag>
);
